var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHide({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48351 3.826C11.8129 3.5484 14.1691 4.04082 16.1924 5.22805C18.2156 6.41528 19.7947 8.23208 20.6885 10.401C20.7718 10.6255 20.7718 10.8725 20.6885 11.097C20.321 11.988 19.8353 12.8255 19.2445 13.587M12.8345 12.908C12.2687 13.4545 11.5109 13.7569 10.7243 13.75C9.93771 13.7432 9.18527 13.4277 8.62905 12.8715C8.07282 12.3152 7.75732 11.5628 7.75048 10.7762C7.74365 9.98961 8.04603 9.23181 8.59251 8.666M16.2295 16.249C14.903 17.0348 13.423 17.526 11.8899 17.6894C10.3568 17.8528 8.80646 17.6845 7.34414 17.1959C5.88182 16.7073 4.5417 15.9099 3.41472 14.8577C2.28773 13.8056 1.40026 12.5234 0.812505 11.098C0.729165 10.8735 0.729165 10.6265 0.812505 10.402C1.69914 8.25186 3.25918 6.44725 5.25851 5.259M0.750505 0.75L20.7505 20.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/Hide.87c5403e95fff8718fe7673aa66c127a.svg";
export { ForwardRef as ReactComponent };